<template>
  <div class="ogBox" v-if="og && og.hasOpenGraphValue" @click="openLink(og.openGraphValue.url)">
    <div v-if="og.openGraphValue.image" :style="{ backgroundImage: `url(${og.openGraphValue.image})` }" class="img"></div>
    <dl>
      <dt>{{ og.openGraphValue.title }}</dt>
      <dd class="txt" v-if="og.openGraphValue.description">{{ og.openGraphValue.description }}</dd>
      <dd class="url">{{ og.openGraphValue.url }}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'OpenGraph',
  props: {
    og: Object
  },
  methods: {
    openLink(url) {
      this.$mitt.emit('windowOpen', {
        url: url,
        target: '',
        features: ''
      });
    }
  }
};
</script>
